import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function Gallery() {
  const [photos, setPhotos] = useState(null);
  useEffect(() => {
    api.get("/gallery").then(({ data }) => setPhotos(data)).catch(() => setPhotos([]));
  }, []);
  return (
    <div className="min-h-screen bg-[#f5fbfd] pt-28 pb-20 px-4">
      <div className="max-w-6xl mx-auto">
        <p className="text-cyan-600 font-semibold tracking-[0.2em] uppercase text-xs mb-3">Gallery</p>
        <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-slate-900 mb-3">
          Life on the <span className="text-cyan-500">water</span>
        </h1>
        <p className="text-slate-600 mb-10 max-w-xl">
          Real moments from our cruises and beach getaways around Grand Cayman.
        </p>
        {photos === null ? (
          <p className="text-slate-400">Loading photos…</p>
        ) : (
          <div data-testid="gallery-grid" className="columns-1 sm:columns-2 lg:columns-3 gap-5 space-y-5">
            {photos.map((p, i) => (
              <figure key={p.id} className="break-inside-avoid rounded-3xl overflow-hidden shadow-xl bg-white fade-up" style={{ animationDelay: `${i * 0.08}s` }}>
                <img src={p.url} alt={p.caption || "Mickey Mouse Charters trip photo"} className={`w-full object-cover ${i % 4 === 3 ? "h-72" : "h-[420px]"}`} loading="lazy" />
                {p.caption && <figcaption className="px-5 py-4 text-sm font-semibold text-slate-700">{p.caption}</figcaption>}
              </figure>
            ))}
            <div className="break-inside-avoid rounded-3xl bg-black p-8 text-center shadow-xl">
              <p className="font-display text-xl font-extrabold text-white mb-2">Want in on the fun?</p>
              <p className="text-sm text-slate-300 mb-5">Grab your crew and join us on the water.</p>
              <Link to="/book" data-testid="gallery-book-cta" className="btn-coral inline-block text-white font-bold px-7 py-3 rounded-full">
                Book a Tour
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
